//var $ = require( 'jquery' );
import inview from 'jquery-inview/jquery.inview';
import lazyLoad from 'vanilla-lazyload/dist/lazyload';
import Headroom from 'headroom.js';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);


$(function () {
	handleInviewAnimate();
	handleHeadroom();
	//initLazyLoad();
	handleHeaderMenuToggling();
	menuFunctionality();

});

$(window).on('load', function () {
	handleParallax();

	$('.site-footer .current-year').text(new Date().getFullYear());
});

function handleHeadroom() {
	var headerElements = document.getElementsByClassName("site-header"),
		headerElementsNo = headerElements.length;

	if (headerElementsNo > 0) {
		for (var i = 0; i < headerElementsNo; i++) {
			var headroom = new Headroom(headerElements[i]);
			headroom.init();
		}
	}
}


function handleInviewAnimate() {
	var inviewElements = $(".inview-animate--fade")
		.add(".inview-animate--move-up")
		.add(".inview-animate--move-down")
		.add(".inview-animate--move-left")
		.add(".inview-animate--move-right")
		.add(".inview-animate--scale");

	inviewElements.each(function () {
		var thisInviewElement = $(this);

		thisInviewElement.bind('inview', function (event, visible) {
			if (visible == true) {
				thisInviewElement.addClass('inview-active');
			}
		});
	});
}


function handleHeaderMenuToggling() {
	var header = $('.site-header'),
		headerMenu = $('.nav-wrap'),
		headerBurger = $('.nav-trigger');

	if (headerMenu.length) {
		headerBurger.on("click", function (e) {
			e.preventDefault();
			var index = 0;

			$('body').toggleClass('noscroll');
			$(this).toggleClass("active");
			headerMenu.toggleClass("menu-active");
			header.toggleClass("nav-active");
		});
	}
}

function menuFunctionality() {
	const menuItems = $('.site-header .menu-item');
	const targetIds = ['#marengo-start001', '#marengo-start002'];

	menuItems.on('click', function (e) {
		const anchor = e.target.closest('a');
		if (!anchor) return;

		const href = anchor.getAttribute('href');

		if (targetIds.some(id => href.includes(id))) {
			menuItems.removeClass('current-menu-item current_page_item');
			$(this).addClass('current-menu-item current_page_item');

			// Close mobile menu
			const header = $('.site-header'),
				headerMenu = $('.nav-wrap'),
				headerBurger = $('.nav-trigger');

			$('body').removeClass('noscroll');
			headerBurger.removeClass('active');
			headerMenu.removeClass('menu-active');
			header.removeClass('nav-active');
		}
	});

	// Highlight menu item on page load based on URL hash
	const currentHash = window.location.hash;
	if (targetIds.includes(currentHash)) {
		menuItems.removeClass('current-menu-item current_page_item');
		menuItems.each((i, item) => {
			const itemHref = $(item).children('a').attr('href');
			if (itemHref.includes(currentHash)) {
				$(item).addClass('current-menu-item current_page_item');
			}
		});
	}
}

function handleParallax() {
	if ($(window).width() > 1200) {
		gsap.to(".parallax-on-text", {//global class to apply
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".parallax-on-text",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".parallax-on-text-1", {//global class to apply
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".parallax-on-text-1",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".parallax-on-text-2", {//global class to apply
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".parallax-on-text-2",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-our-team .members", {//global class to apply
			yPercent: -10,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-our-team .members",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".science-page-cell-activation .parallax-on-text-3", {//global class to apply
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".science-page-cell-activation .parallax-on-text-3",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".final-section .parallax-on-text-3", {//global class to apply
			yPercent: -50,
			ease: "none",
			scrollTrigger: {
				trigger: ".final-section .parallax-on-text-3",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".pipeline-page .parallax-on-text-3", {//global class to apply
			yPercent: -60,
			ease: "none",
			scrollTrigger: {
				trigger: ".pipeline-page .parallax-on-text-3",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	}

	//##START HOMEPAGE
	if ($(window).width() > 992) {//HERO desktop
		gsap.to(".parallax-on-text-hero", {
			yPercent: -40,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-hero .cell-1, .section-hero .cell-2", {
			yPercent: 400,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-hero .cell-3", {
			yPercent: -300,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-hero .cell-4", {
			yPercent: -100,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-hero .cell-5", {
			yPercent: -150,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});

	} else {// HERO tablet and mobile

		//##START HERO
		gsap.to(".section-hero .cell-3", {
			yPercent: -300,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner .small-text",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});

		gsap.to(".section-hero .cell-4", {
			yPercent: -100,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner .small-text",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});

		gsap.to(".section-hero .cell-5", {
			yPercent: -150,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-about .inner .small-text",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		//##END HERO

	};

	gsap.to(".section-home-about .image", {
		yPercent: 10,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-home-about .line",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	if ($(window).width() > 1200) {
		gsap.to(".section-home-approach .cell-image", {
			yPercent: -40,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-home-approach .container",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	}
	//##END HOMEPAGE


	//##START SCIENCE PAGE
	gsap.to(".section-text-and-cells .cell", {
		yPercent: -70,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-science-anti-v",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-gradient-and-text.science-page-cell-activation .cell-1", {
		yPercent: 50,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-gradient-and-text .h2",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-gradient-and-text.science-page-cell-activation .cell-2", {
		yPercent: 110,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-gradient-and-text .h2",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-gradient-and-text.science-page-cell-activation .cell-3", {
		yPercent: 110,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-gradient-and-text .h2",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-gradient-and-text.science-page-cell-activation .cell-4", {
		yPercent: -100,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-gradient-and-text .small-text",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-gradient-and-text.science-page-cell-activation .cell-5", {
		yPercent: -100,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-gradient-and-text .small-text",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});

	if ($(window).width() > 992) {//desktop
		gsap.to(".section-gradient-and-text.science-page-pipeline-section .cell-1", {
			yPercent: -50,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-gradient-and-text.science-page-pipeline-section .cta",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-gradient-and-text.science-page-pipeline-section .cell-4", {
			yPercent: 70,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-gradient-and-text.science-page-pipeline-section",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-gradient-and-text.science-page-pipeline-section .cell-5", {
			yPercent: 100,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-gradient-and-text.science-page-pipeline-section",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	} else {
		gsap.to(".section-gradient-and-text.science-page-pipeline-section .cell-1", {
			yPercent: 80,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-gradient-and-text.science-page-pipeline-section .cta",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-gradient-and-text.science-page-pipeline-section .cell-4", {
			yPercent: -10,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-gradient-and-text.science-page-pipeline-section .cta",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".section-gradient-and-text.science-page-pipeline-section .cell-5", {
			yPercent: -100,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-gradient-and-text.science-page-pipeline-section .cta",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	}
	//##END SCIENCE PAGE

	//##START PIPELINE PAGE
	if ($(window).width() > 767) {//desktop
		gsap.to(".section-gradient-and-text.pipeline-page .cell-4", {
			yPercent: -70,
			ease: "none",
			scrollTrigger: {
				trigger: ".pipeline-parallax-trigger",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	} else {
		gsap.to(".section-gradient-and-text.pipeline-page .cell-4", {
			yPercent: 30,
			ease: "none",
			scrollTrigger: {
				trigger: ".pipeline-parallax-trigger",
				// start: "bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	}
	//##END PIPELINE PAGE

	//##START JOIN US PAGE
	gsap.to(".section-our-values .image-top", {
		yPercent: 10,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-our-values .line",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	if ($(window).width() < 1200) {//desktop
		gsap.to(".section-our-values .cards-container", {
			yPercent: -10,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-our-values .cards-container",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	} else {
		gsap.to(".section-our-values .cards-container", {
			yPercent: -30,
			ease: "none",
			scrollTrigger: {
				trigger: ".section-our-values .cards-container",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	}
	gsap.to(".section-our-values .image-bottom", {
		yPercent: -10,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-our-values .line-bottom",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-testimonials", {
		yPercent: -20,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-testimonials",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-testimonials .image-bottom", {
		yPercent: 10,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-testimonials .line-bottom",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	gsap.to(".section-join-our-team .image-top", {
		yPercent: 10,
		ease: "none",
		scrollTrigger: {
			trigger: ".section-join-our-team .line",
			// start: "top bottom", // the default values
			// end: "bottom top",
			scrub: true,
		},
	});
	//##END JOIN US PAGE

	//##START NEWS PAGE
	setTimeout(function () {
		if ($(window).width() > 1200) {//desktop
			gsap.to(".parallax-on-text-4", {
				yPercent: -20,
				ease: "none",
				scrollTrigger: {
					trigger: ".parallax-on-text-4",
					// start: "top bottom", // the default values
					// end: "bottom top",
					scrub: true,
				},
			});
			gsap.to(".news-page-atp-section .parallax-on-text-3", {
				yPercent: -20,
				ease: "none",
				scrollTrigger: {
					trigger: ".news-page-atp-section .parallax-on-text-3",
					// start: "top bottom", // the default values
					// end: "bottom top",
					scrub: true,
				},
			});
		}
		gsap.to(".news-page-atp-section .cell-1", {
			yPercent: 60,
			ease: "none",
			scrollTrigger: {
				trigger: ".news-page-atp-section .dots-illustration",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".news-page-atp-section .cell-2", {
			yPercent: 110,
			ease: "none",
			scrollTrigger: {
				trigger: ".news-page-atp-section .dots-illustration",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".news-page-atp-section .cell-3", {
			yPercent: 130,
			ease: "none",
			scrollTrigger: {
				trigger: ".news-page-atp-section .dots-illustration",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".news-page-atp-section .cell-4", {
			yPercent: -90,
			ease: "none",
			scrollTrigger: {
				trigger: ".news-page-atp-section .ff-aktiv",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
		gsap.to(".news-page-atp-section .cell-5", {
			yPercent: -120,
			ease: "none",
			scrollTrigger: {
				trigger: ".news-page-atp-section .ff-aktiv",
				// start: "top bottom", // the default values
				// end: "bottom top",
				scrub: true,
			},
		});
	}, 2000);

	//##END NEWS PAGE

}

/* function initLazyLoad() {
const lazy = new lazyLoad({
elements_selector: '.lazy',
load_delay: 300
});

let variableSrc = 'src-desktop';
if( $(window).width() < 768 ) {
variableSrc = 'src-mobile';
}

const bgLazy = new lazyLoad({
elements_selector: '.lazy-bg',
data_bg: variableSrc,
load_delay: 300
});

const imgLazy = new lazyLoad({
elements_selector: '.lazy-img',
data_src: variableSrc,
load_delay: 300
});

let heroLazy = new lazyLoad({
elements_selector: '.lazy-hero',
data_bg: variableSrc,
load_delay: 0
});

heroLazy.loadAll();
} */
